import type { Popup } from "@schemas/popup";

import instance from "@utils/axiosInstance";
import { useCreateQuery, type QueryOpts } from "@utils/generateReactQuery";

const BASE_URL = "/popups";

const API = {
	getList: async () => await instance.get(`${BASE_URL}`),
};

const KEY = {
	getList: () => ["/popups"],
};

export function useGetPopups(options?: QueryOpts<Popup[]>) {
	return useCreateQuery<Popup[]>(KEY.getList(), () => API.getList(), {
		...options,
	});
}
